import * as React from "react";
import { forwardRef } from "react";
const SvgIconExternalLink = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.091 5v1.091h3.034l-6.7 6.7.784.784 6.7-6.7v3.034H17V5zM5 7.182V17h9.818V9.909L13.727 11v4.909H6.091V8.273H11l1.091-1.091z", "data-name": "icon/enternallink", transform: "translate(-5 -5)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconExternalLink);
export { ForwardRef as ReactComponent };
